import { Component, EventEmitter, forwardRef, Input, ViewChild } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";

@Component({
  selector: "core-ui-alert",
  templateUrl: "./alert.component.html",
  styleUrls: ["./alert.component.scss"],
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CoreUiAlertComponent),
      multi: true
    }
  ]
})
export class CoreUiAlertComponent {
  @Input() variant: string = 'info';
  @Input() title: string | null = null;
  @Input() message: string | null = null;
  @Input() icon: string | null = null;

  get iconSrc(): string | null {
    switch (this.icon) {
      case 'lock':
        return 'assets/core-ui/icons/locked_16px.svg';
      case 'server':
        return 'assets/core-ui/icons/exclamation_circle.svg';
      case 'info':
        return 'assets/core-ui/icons/ic_Info_24px.svg';
      case 'warning':
        return 'assets/core-ui/icons/ic_Warning_24px.svg';
      case 'intentos':
        return 'assets/core-ui/icons/icon_close-red.svg';
      default:
        return null;
    }
  }

  get iconAlt(): string {
    switch (this.icon) {
      case 'lock':
        return 'Cuenta bloqueada';
      case 'server':
        return 'Error de servidor';
      case 'info':
        return 'Información';
      case 'warning':
        return 'Advertencia';
      case 'intentos':
        return 'Cerrar';
      default:
        return '';
    }
  }
}